<template>
    <div style="text-align: center; font-size: 22px; padding: 10px;">请使用钉钉扫码在手机查看</div>
    <div id="qrcode-1"></div>
    <el-drawer v-model="visible" :show-close="false" size="100%" :title="message.title">
        <div v-for="(item, i) in message.messages" :key="i">
            <el-row justify="space-between">
                <el-col v-for="(col, ci) in item" :key="ci" :span="'span' in col ? col.span : (24 / col.length)"
                    :xs="'xs' in col ? col.xs : (24 / col.length)">
                    <div v-if="col.label == 'list'" style="text-align: left;">
                        <div v-for="(list, li) in col.value" :key="li">
                            {{list}}
                        </div>
                    </div>
                    <div v-else-if="col.label == 'table'">
                        <el-table :data="col.data" :style="'width: '+ (screenWidth-40) +'px;'">
                            <el-table-column v-for="(item, index) in col.columns" :key="index" :label="item.label"
                                :prop="item.property" show-overflow-tooltip>
                                <template #header>
                                    {{item.label}}
                                    <el-tooltip effect="light" v-if="item.tooltip" :content="item.tooltip">
                                        <el-icon style="font-size: 12px; color: bottom: ;">
                                            <InfoFilled />
                                        </el-icon>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else>
                        {{col.value}}
                        <el-tooltip effect="light" :content="col.tip" v-if="'tip' in col">
                            <el-icon style="font-size: 12px; color: bottom: ;">
                                <InfoFilled />
                            </el-icon>
                        </el-tooltip>
                    </div>
                </el-col>
            </el-row>
            <el-divider />
        </div>
        <template #footer>
            <div v-if="message.confirm" style="font-weight: bold;">{{message.confirm}}</div>
            <div v-else>
                <el-button @click="doubtButton()" :disabled="message.doubt_dashed">{{message.doubt_label}}</el-button>
                <el-button type="primary" @click="confirmButton()" :disabled="message.confirm_dashed">
                    {{message.confirm_label}}
                </el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
    import {
        ElMessage,
        ElMessageBox
    } from 'element-plus'
    import axios from "@/utils/request";
    import {
        isDingTalk
    } from '@/utils/dingtalk'
    import QRCode from 'qrcode';
    import {
        mapState
    } from 'vuex'
    export default {
        name: 'MessageNotice',
        computed: {
            // Vue计算属性
            ...mapState(['route', 'domain', 'screenWidth'])
        },
        data() {
            return {
                visible: true,
                deviceType: true,
                message: {
                    title: "消息通知",
                    identity: "测试",
                    confirm_dashed: true,
                    confirm_label: "朕准了",
                    doubt_dashed: true,
                    doubt_label: "有疑问",
                    confirm: "",
                    messages: []
                }
            }
        },
        mounted() {
            if (JSON.stringify(this.$route.query) === '{}') {
                this.arrMessage()
                return
            }
            if ("title" in this.$route.query) {
                document.title = this.$route.query.title
            }
            if (this.$route.query.fun === undefined) {
                this.getDeviceType()
                this.deviceType = false
                return
            }
            this.refreshData()
        },
        methods: {
            arrMessage(msg) {
                ElMessageBox.alert(msg ? msg : '加载失败，缺少请求参数！', '提示', {
                    confirmButtonText: '好的',
                    callback: () => {
                        this.backHome()
                    },
                })
            },
            backHome() {
                if (this.route[0].tabsName.length) {
                    this.$router.push(`/${this.route[0].path}?id=${this.route[0].tabsName[0]}`)
                } else {
                    this.$router.push(`/${this.route[0].path}`)
                }
            },
            refreshData() {
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: {
                        tabname: "消息通知",
                        search: "",
                        query: this.$route.query
                    },
                }).then(res => {
                    if (res.arr) {
                        this.arrMessage(res.data)
                    } else {
                        this.message = res
                    }
                })
            },
            doubtRequest() {
                ElMessage({
                    type: 'success',
                    message: '已经联系管理员',
                })
                axios({
                    method: "post",
                    url: 'updata',
                    data: {
                        tabname: "消息通知",
                        search: "",
                        query: this.$route.query,
                        doubt: true,
                        confirm: false
                    },
                }).then(() => {
                    ElMessage({
                        type: 'success',
                        message: '反馈已经送达',
                    })
                })
            },
            doubtButton() {
                if (this.deviceType) {
                    ElMessageBox.confirm(
                            `你是 ${this.message.identity} 吗？`,
                            '提示', {
                                confirmButtonText: '我是，请联系管理员',
                                cancelButtonText: '我不是，重新登录查看',
                                type: 'warning',
                            }
                        )
                        .then(() => {
                            this.doubtRequest()
                        })
                        .catch(async () => {
                            await window.sessionStorage.clear()
                            await window.localStorage.clear()
                            await window.location.reload()
                            localStorage.setItem('continue', window.location.hash.replace('#', ""))
                            let lri = encodeURIComponent(`${this.domain}`)
                            let params =
                                `prompt=consent&client_id=dingcbr6uco9yqfeo6wf&response_type=code&scope=openid&state=1&redirect_uri=${lri}`
                            window.location.href = `https://login.dingtalk.com/oauth2/auth?${params}`
                        })
                } else {
                    this.doubtRequest()
                }
            },
            confirmButton() {
                this.message.confirm_dashed = true
                this.message.confirm_label = "已确认"
                axios({
                    method: "post",
                    url: 'updata',
                    data: {
                        tabname: "消息通知",
                        search: "",
                        query: this.$route.query,
                        mag: "已确认",
                        doubt: false,
                        confirm: true
                    },
                }).then(() => {
                    ElMessage({
                        type: "success",
                        message: `已提交`,
                    })
                })
            },
            getDeviceType() {
                let con = 0
                if (isDingTalk()) {
                    con++
                }
                const ua = navigator.userAgent;
                // 手机检测 排除 平板
                if (/iphone|ipod|android|windows phone|mobile|webos|blackberry|iemobile|opera mini/i.test(ua)) {
                    con++
                }
                if (con == 2) {
                    this.refreshData()
                    return true;
                }
                this.visible = false
                QRCode.toCanvas(window.location.href, {
                    errorCorrectionLevel: 'H'
                }, function(err, canvas) {
                    if (err) throw err
                    const container = document.getElementById('qrcode-1')
                    if (container.children.length == 0) {
                        container.appendChild(canvas)
                    }
                })
                return false
            },
        }
    }
</script>

<style scoped less>
</style>